import { Statistic, Text } from "@/atoms"
import { CaretDownOutlined, CaretUpOutlined } from "@/icons"

import styles from "./StatisticDifference.module.scss"

import type { StatisticDifferenceProps } from "."

export const StatisticDifference = (props: StatisticDifferenceProps) => {
  const {
    noTrend,
    isNeutral,
    isPositive,
    title,
    value,
    reverse,
    testId = "StatisticDifference"
  } = props

  let colorCssVariableName = isPositive
    ? "--exceptional-score"
    : "--unsatisfactory-score"

  if (isNeutral) colorCssVariableName = "--neutral-score"
  const UpIcon = reverse ? CaretDownOutlined : CaretUpOutlined
  const DownIcon = reverse ? CaretUpOutlined : CaretDownOutlined
  const PrefixComponent = isPositive ? UpIcon : DownIcon

  return (
    <Statistic
      className={styles.wrapStatisticDifference}
      title={
        <Text
          type="secondary"
          className={styles.title}
          data-testid={`${testId}-text`}
        >
          {title}
        </Text>
      }
      value={value}
      styles={{
        content: {
          color: `var(${colorCssVariableName})`,
          fontSize: "var(--md-font-size)"
        }
      }}
      prefix={!noTrend && <PrefixComponent data-testid={`${testId}-prefix`} />}
    />
  )
}
